import { useOutletContext } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { dispatch } from 'modules/core/lib/pubSub'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { LaunchBanner } from 'modules/finance/components/FinancialWorkspace/components/LaunchBanner'
import { REFETCH_DATA_EVENT } from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import { usePayrollSummaryImportButton } from 'modules/payroll_bundle/hooks/usePayrollSummaryImportButton'

export const localStorageKey = 'financialWorkspacePayrollBanner'

interface Props {
  onRestore?: () => void
  onClose?: () => void
}

export const Banner = ({ onRestore, onClose }: Props) => {
  const {
    availabilities: {
      modules: { expenses },
    },
  } = useFinancialWorkspace()
  const missingExpensesModule = !expenses

  const { seePayrollLanding } = useOutletContext<{
    seePayrollLanding: boolean
  }>()

  const { canSeeButton, loading } = usePayrollSummaryImportButton()

  const onFinishPayroll = () => {
    dispatch({ type: REFETCH_DATA_EVENT })
  }

  const title = missingExpensesModule
    ? i18n.t('finance.financial_workspace.launch_banner.payroll.expenses.title')
    : i18n.t('finance.financial_workspace.launch_banner.payroll.title')

  const description = missingExpensesModule
    ? i18n.t('finance.financial_workspace.launch_banner.payroll.expenses.description')
    : i18n.t('finance.financial_workspace.launch_banner.payroll.description')

  const displayLink = !loading && !canSeeButton

  if (!missingExpensesModule && !seePayrollLanding) {
    return null
  }

  return (
    <LaunchBanner
      title={title}
      description={description}
      localStorageKey={localStorageKey}
      source={'fw-payroll-data'}
      onRestore={onRestore}
      onFinishPayroll={onFinishPayroll}
      onClose={onClose}
      {...(displayLink && {
        link: {
          title: i18n.t('finance.financial_workspace.launch_banner.payroll.link'),
        },
      })}
      buttonsConfig={{
        payroll: {
          visible: canSeeButton,
          type: 'outline',
        },
        expenses: {
          visible: missingExpensesModule,
        },
      }}
      modulesAvailability={{
        expenses: !missingExpensesModule,
        payroll: !seePayrollLanding,
      }}
    />
  )
}
